import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, throwError } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class GivingService {

  [x: string]: any;
  open(arg0: { key: any; entity: any }) {
    throw new Error("Method not implemented.");
  }

  constructor(private http: HttpClient) { }
  // getOfferingsByServiceNumber(serviceNumber: string): Observable<any> {
  //   const url = `${environment.baseUrl}/api/offerings/by-service-number/${serviceNumber}`;
  //   return this.http.get<any[]>(url);
  // }
  public getCheques(): Observable<any> {
    const chequesUrl = `${environment.baseUrl}/api/cheque-payments`;

    return this.http.get<any[]>(chequesUrl);
  }
  
   public getAllOffertories(churchUnitId: any): Observable<any> {
    const offertoriesUrl = `${environment.baseUrl}/api/offertories/unit/${churchUnitId}/reports/community-offertory`;
    return this.http.get<any[]>(offertoriesUrl);
  }

  public getTotalOffertories(parishId: any): Observable<any> {
    const offertoriesUrl = `${environment.baseUrl}/api/offertories/monthlySadakaTotals/${parishId}`;
    return this.http.get<any>(offertoriesUrl);
  }

  // public getTotalTithes(): Observable<any> {
  //   const tithesUrl = `${environment.baseUrl}/api/tithes/monthlyTitheTotals`;
  //   return this.http.get<any>(tithesUrl);
  // }
  public getTotalTithes(churchUnitId: number): Observable<any> {
    const tithesUrl = `${environment.baseUrl}/api/tithes/unit/${churchUnitId}/reports/monthlyTotal`;
    return this.http.get<any>(tithesUrl);
  }

  // public getTotalPdfs(): Observable<any> {
  //   const pdfUrl = `${environment.baseUrl}/api/pdf/monthlypdfTotals`;
  //   return this.http.get<any>(pdfUrl);
  // }

  public getTotalPdfs(churchUnitId: number): Observable<any> {
    const pdfUrl = `${environment.baseUrl}/api/pdf/unit/${churchUnitId}/reports/monthlyTotal`;
    return this.http.get<any>(pdfUrl);
  }

  // public getTotalDonations(): Observable<any> {
  //   const donationUrl = `${environment.baseUrl}/api/donations/monthlyDonationsTotals`;
  //   return this.http.get<any>(donationUrl);
  // }
  public getAllDonation(churchUnitId: number):Observable<any> {
    const donationUrl = `${environment.baseUrl}/api/donation-transactions/unit/${churchUnitId}/reports/total-amount`;
    return this.http.get<any>(donationUrl);
  }
  public getTotalDonations(churchUnitId: number): Observable<any> {
    const donationUrl = `${environment.baseUrl}/api/donation-transactions/unit/${churchUnitId}/reports/monthly`;
    return this.http.get<any>(donationUrl);
  }

  public getTotalDdfs(churchUnitId: number): Observable<any> {
    const ddfUrl = `${environment.baseUrl}/api/ddf/unit/${churchUnitId}/reports/monthlyTotal`;
    return this.http.get<any>(ddfUrl);
  }

  public getTotalThanksgiving(churchUnitId: number): Observable<any> {
    const thanksgivingUrl = `${environment.baseUrl}/api/v1/thanksgiving/unit/${churchUnitId}/reports/monthlyTotal`;
    return this.http.get<any>(thanksgivingUrl);
  }

  public getAllThanksgiving(churchUnitId: any): Observable<any> {
    const thanksgivingUrl = `${environment.baseUrl}/api/v1/thanksgiving/unit/${churchUnitId}/reports/all/withParticipants`;
    return this.http.get<any[]>(thanksgivingUrl);
  }

  public getAllStageTransactions(churchUnitId: any): Observable<any> {
    const stageTransactionsUrl = `${environment.baseUrl}/api/v1/stage-transactions/unit/${churchUnitId}/reports/all/withParticipants`;
    return this.http.get<any[]>(stageTransactionsUrl);
  }

  public getTotalStageTransactions(churchUnitId: number): Observable<any> {
    const stageTransactionsUrl = `${environment.baseUrl}/api/v1/stage-transactions/unit/${churchUnitId}/reports/monthlyTotal`;
    return this.http.get<any>(stageTransactionsUrl);
  }

  // public getAllTithes( parishId: any): Observable<any> {
  //   const tithesUrl = `${environment.baseUrl}/api/tithes/get/all/${parishId}/totals/per/community/with/participants`;

  //   return this.http.get<any[]>(tithesUrl);
  // }
public getAllTithes( churchUnitId: any): Observable<any> {
    const tithesUrl = `${environment.baseUrl}/api/tithes/unit/${churchUnitId}/reports/all/withParticipants`;

    return this.http.get<any[]>(tithesUrl);
  }
  

//   public getAllPdfs(parishId: any, churchUnitId: number): Observable<any> {
//     const pdfUrl = `${environment.baseUrl}/api/pdf/unit/${churchUnitId}/reports/monthly-transactions/byOutstation
// `;
//     const params = new HttpParams().set('parishId', parishId);
//     console.log('PDF URL:', pdfUrl, 'with params:', params.toString());
//     return this.http.get<any[]>(pdfUrl, { params: params });
//   }

public getAllPdfs(churchUnitId: number): Observable<any> {
  const pdfUrl = `${environment.baseUrl}/api/pdf/unit/${churchUnitId}/reports/community-transactions`;
  console.log('PDF URL:', pdfUrl);
  return this.http.get<any[]>(pdfUrl);
}

  
  
  

  //get all donations
  public getAllDonations(userName: any): Observable<any> {
    const donations = `${environment.baseUrl}/api/donation-transactions/get/all/monthly/donations`;
    return this.http.get<any[]>(donations);

  }

  public getAllDdfs(parishId: any): Observable<any[]> {
    const ddfUrl = `${environment.baseUrl}/api/ddf/get/all/by/outStation/for-all-transaction-methods`;
    const params = new HttpParams().set('parishId', parishId);
    console.log('Fetching DDF data from URL:', ddfUrl, 'with params:', params.toString());
    return this.http.get<any[]>(ddfUrl, { params: params });
  }

  //  //getAllPdfParishes
  //  public getAllPdfParishes(userName: any):Observable<any>{
  //   const donations=`${environment.baseUrl}/api/pdf/parish/getAll`;
  //   return this.http.get<any[]>(donations);

  // }

  //getServicesForWeek
  public getServicesForWeek(userName: any): Observable<any> {
    const offertories = `${environment.baseUrl}/api/offertories/weeklyServicesOrMassesSadakaCollection`;
    return this.http.get<any[]>(offertories);

  }
  // get cashPayments http://102.210.244.222:8901/api/cash-payments
  public getCashPayments(): Observable<any> {
    const cashPaymentsUrl = `${environment.baseUrl}/api/cash-payments`;
    return this.http.get<any[]>(cashPaymentsUrl);
  }
  //Post cash sadaka to the database
  PostCash(data: any): Observable<any> {
    // Append parishId as a query parameter.
    const cashUrl = `${environment.baseUrl}/api/cash-payments/depositCash`;
    return this.http.post<any>(cashUrl, data);
  }
  // public getAllPdfs(parishId: any): Observable<any> {
  //   const pdfUrl = `${environment.baseUrl}/api/pdf/get/all/by/outStation/for-all-transaction-methods`;
  //   const params = new HttpParams().set('parishId', parishId);
  //   console.log('PDF URL:', pdfUrl, 'with params:', params.toString());
  //   return this.http.get<any[]>(pdfUrl, { params: params });
  // }
  

  // approveRecord(adminMemberNumber: string, transactionId: string): Observable<any> {
  //   const offertoryUrl = `${environment.baseUrl}/api/cash-payments/${transactionId}/approve?memberNumber=${adminMemberNumber}`;
  //   const params = new HttpParams().set('memberNumber', adminMemberNumber);
  //   return this.http.post<any>(offertoryUrl, null, { params });
  // }

  approveRecord(transactionId: number, memberNumber: string): Observable<any> {
    const url = `${environment.baseUrl}/api/cash-payments/${transactionId}/approve`;
    const params = new HttpParams().set('memberNumber', memberNumber);
        return this.http.post<any>(url, null, { params });
  }
  



  //get current user details by username
  public getUserdetailsByUsername(userName: string): Observable<any> {
    const detailUrl = `${environment.baseUrl}/api/v1/auth/find/by/username/${userName}`;

    return this.http.get<any>(detailUrl);
  }

  //Post cheque into the database
  public postCheque(checkData: any): Observable<any> {
    const chequeUrl = `${environment.baseUrl}/api/cheque-payments/save/cheque`;

    return this.http.post<any>(chequeUrl, checkData);
  }

  //get all cheque data from the database
  public getAllCheques(): Observable<any[]> {
    const allChequeUrl = `${environment.baseUrl}/api/cheque-payments`;

    return this.http.get<any[]>(allChequeUrl);
  }

  // approveRecord(transactionId: number, memberNumber: string): Observable<any> {
  //   const url = `${this.baseUrl}/api/cash-payments/${transactionId}/approve`;
  //   const params = new HttpParams().set('memberNumber', memberNumber);
    
  //   return this.http.post<void>(url, null, { params });
  // }

  //Approve cheque in the database
  approveCheque( transactionId: number,memberNumber: string): Observable<any>{
    const approveUrl = `${environment.baseUrl}/api/cheque-payments/${transactionId}/approve`;
    const params =  new HttpParams().set('memberNumber', memberNumber)

    return this.http.post<any>(approveUrl,null, {params});
  }

  updateOfferingArchiveStatus(id: string, archiveStatus: boolean): Observable<any> {
    return this.http.patch(`${environment.baseUrl}/api/offerings/${id}/archive`, {
      archived: archiveStatus
    });
  }
  
  getArchivedOfferings(): Observable<any> {
    return this.http.get(`${environment.baseUrl}/api/offerings/archived`);
  }

  public activeWallets(): Observable<any> {
    const allWalletsUrl = `${environment.baseUrl}/api/v1/Wallets/get/Active`;
    return this.http.get<any>(allWalletsUrl);
  }

  public getAllGuestOfferings(churchUnitId: any): Observable<any> {
    const guestOfferingsUrl = `${environment.baseUrl}/api/paybill/unit/${churchUnitId}/monthly-summary`;
    return this.http.get<any[]>(guestOfferingsUrl);
  }

  public getUniversalCollection(churchUnitId: any): Observable<any> {
    const universalCollectionUrl = `${environment.baseUrl}/api/v1/universal-collection/${churchUnitId}/current`;
    return this.http.get<any[]>(universalCollectionUrl);
  }

  public getPaymentAccountOptions(churchUnitId: number, paymentType: string): Observable<any> {
    return this.http.get(`${environment.baseUrl}/api/v1/church-units/${churchUnitId}/payment-account-links/options?paymentType=${paymentType}`);
  }

  public createPaymentAccountLink(churchUnitId: number, payload: any): Observable<any> {
    return this.http.post(`${environment.baseUrl}/api/v1/church-units/${churchUnitId}/payment-account-links`, payload);
  }

}

